<template>
	<div class="input__field">
		<CalcElem
			v-for="(element, index) in elements"
			:name="index"
			:key="index"
			:options="element"
			:type="type"
			:class="element.inputClass"
			:disabled="isLocked(element.locked)"
			:ref="computedIndex(index)"
		/>
	</div>
</template>

<script>
import { each } from 'lodash';

export default {
	mounted() {
		const refs = {
			parcel_number: this.refGroup !== null ? `${this.refGroup}-parcel_number` : 'parcel_number',
			from_house_number: this.refGroup !== null ? `${this.refGroup}-from_house_number` : 'from_house_number',
			mobile_number: this.refGroup !== null ? `${this.refGroup}-mobile_number` : 'mobile_number',
			phone_number: this.refGroup !== null ? `${this.refGroup}-phone_number` : 'phone_number',
		};

		each(refs, (ref, index) => {
			if (this.$refs[ref] !== undefined) {
				if (this.$refs[ref][0].$refs.component.$refs.provider !== undefined) {
					if (this.$refs[ref][0].$refs.component.$refs.provider.vid !== undefined) {
						if (this.$refs[refs.parcel_number] !== undefined) {
							if (
								index === 'from_house_number' &&
								this.$refs[refs.parcel_number][0].$refs.component.$refs.provider !== undefined
							) {
								this.$refs[ref][0].$refs.component.addRules({
									required_target: {
										target: `@${
											this.$refs[refs.parcel_number][0].$refs.component.$refs.provider.vid
										}`,
									},
								});
							}
						}

						if (this.$refs[refs.from_house_number] !== undefined) {
							if (
								index === 'parcel_number' &&
								this.$refs[refs.from_house_number][0].$refs.component.$refs.provider !== undefined
							) {
								this.$refs[ref][0].$refs.component.addRules({
									required_target: {
										target: `@${
											this.$refs[refs.from_house_number][0].$refs.component.$refs.provider.vid
										}`,
									},
								});
							}
						}

						if (this.$refs[refs.phone_number] !== undefined) {
							if (
								index === 'mobile_number' &&
								this.$refs[refs.phone_number][0].$refs.component.$refs.provider !== undefined
							) {
								this.$refs[ref][0].$refs.component.addRules({
									required_target: {
										target: `@${
											this.$refs[refs.phone_number][0].$refs.component.$refs.provider.vid
										}`,
									},
								});
							}
						} else {
							if(index === 'mobile_number') {
								this.$refs[ref][0].$refs.component.addRules({
									required: true
								});
							}
						}

						if (this.$refs[refs.mobile_number] !== undefined) {
							if (
								index === 'phone_number' &&
								this.$refs[refs.mobile_number][0].$refs.component.$refs.provider !== undefined
							) {
								this.$refs[ref][0].$refs.component.addRules({
									required_target: {
										target: `@${
											this.$refs[refs.mobile_number][0].$refs.component.$refs.provider.vid
										}`,
									},
									wired_cant_be_mobile: {
										target: `@${
											this.$refs[refs.mobile_number][0].$refs.component.$refs.provider.vid
										}`,
									},
								});
							}
						} else {
							if(index === 'phone_number') {
								this.$refs[ref][0].$refs.component.addRules({
									required: true
								});
							}
						}
					}
				}
			}
		});
	},
	props: {
		elements: {
			type: [Array, Object],
			required: true,
		},
		type: {
			type: String,
			default: 'contracting',
		},
		refGroup: {
			type: String,
			default: null,
		},
	},
	computed: {
		isLocked() {
			return locked => (locked !== undefined ? locked : false);
		},
		computedIndex() {
			return index => (this.refGroup !== null ? `${this.refGroup}-${index}` : index);
		},
	},
};
</script>
